<template>
    <el-popover
        placement="top-end"
        trigger="manual"
        :content="content"
        popper-class="error-popover"
        v-model="popoverShow">
        <el-input 
            slot="reference"
            v-model="valueActive" 
            :maxlength='50' 
            size="mini"
            :placeholder="placeholder"
            @blur="handleBlur"
        ></el-input>
    </el-popover>
</template>
<script>
// 文本错误提示
export default {
    name: 'PopoverText',
    props: {
        content: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        value: { type: String, default: '' },
    },
    data() {
        return {
            popoverShow: false,
            valueActive: ''
        }
    },
    watch: {
        'value': {
            handler(newV) {
                this.valueActive = newV
            },
            immediate: true,
        },
    },
    created(){
    },
    methods:{
        setPopoverShow() {
            this.popoverShow = true
            setTimeout(() => {
                this.valueActive = this.value
            })
            setTimeout(() => {
                this.popoverShow = false
            }, 2000)
        },
        setPopoverHide() {
            this.$emit('setQuesCode', this.valueActive)
            this.popoverShow = false
        },
        handleBlur() {
            this.$emit('quesCodeChange',this.valueActive)
        },
    }
}
</script>
